export interface EmailPreference {
    orgId?: string;
    eventType?: string;
    subscriptionId?: string;
    displayName?: string;
}

export interface UnsubscribeDetails {
    email: string;
    preferences: EmailPreference[];
}

export interface NotificationPreferencesState {
    unsubscribeDetails: UnsubscribeDetails | null;
    emailPreferences: EmailPreference[];
    loading: boolean;
    error: string | null;
    unsubscribeSuccess: boolean;
    deleteSuccess: boolean;
}

export const notificationPreferencesState: NotificationPreferencesState = {
    unsubscribeDetails: null,
    emailPreferences: [],
    loading: false,
    error: null,
    unsubscribeSuccess: false,
    deleteSuccess: false,
};
